var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7072 14.249L26.7159 12.5063L21.3555 1.63908C21.2091 1.34154 20.9683 1.10068 20.6707 0.954271C19.9245 0.585892 19.0177 0.892875 18.6446 1.63908L13.2843 12.5063L1.29303 14.249C0.962436 14.2962 0.660176 14.4521 0.428758 14.6882C0.148986 14.9758 -0.00518049 15.3626 0.000132928 15.7638C0.00544635 16.165 0.169805 16.5476 0.457094 16.8277L9.1329 25.2862L7.0832 37.2302C7.03514 37.508 7.06588 37.7938 7.17195 38.0551C7.27802 38.3163 7.45518 38.5426 7.68332 38.7083C7.91147 38.874 8.18148 38.9725 8.46273 38.9925C8.74399 39.0126 9.02524 38.9534 9.27459 38.8218L20.0001 33.1828L30.7256 38.8218C31.0184 38.9776 31.3585 39.0296 31.6843 38.9729C32.5061 38.8312 33.0587 38.052 32.917 37.2302L30.8673 25.2862L39.5431 16.8277C39.7792 16.5962 39.9351 16.294 39.9823 15.9634C40.1098 15.1369 39.5337 14.3718 38.7072 14.249Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGray);
export default __webpack_public_path__ + "static/media/rating_gray.e1a3da5cf69bfad9179a69dded3aad91.svg";
export { ForwardRef as ReactComponent };